import {
  createContext,
  useEffect,
  useState,
  useCallback,
  useContext,
} from "react";
import axios from "axios";
import api from "../components/auth/AddAuthHeader";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [eventSeriesData, setEventSeriesData] = useState([]);
  const [eachEventSerieData, setEachEventSerieData] = useState({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [numbOfEvents, setNumbOfEvents] = useState({});
  const [numbOfSignups, setNumbOfSignups] = useState({});
  const [nextEventIn, setNextEventIn] = useState({});

  const [totalAttendees, setTotalAttendees] = useState({});

  const [listOfUserSubmissions, setListOfUserSubmissions] = useState([]);
  const [markFormObject, setMarkFormObject] = useState([]);

  const [markFormTotalSignups, setMarkFormTotalSignups] = useState({});

  const [populateEachMarkForm, setPopulateEachMarkForm] = useState({});
  const [listOfMarkFormSubmissions, setListOfMarkFormSubmissions] = useState(
    []
  );

  const [getCopperDuplicatesLeads, setGetCopperDuplicatesLeads] = useState([]);

  const handlePopulateEventSeries = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get("/event_series");

      setEventSeriesData(response.data);
       console.log("Response Data inside handle:", response.data);
    } catch (error) {
      console.log(error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handlePopulateEachEventSeries = useCallback(async (path = ``,show_on_form=false,showOnlyDisabledEvents=false) => {
    setLoading(true);
    const show_on_form_string = show_on_form.toString();
    const showOnlyDisabledEvents_string = showOnlyDisabledEvents.toString();

    try {
      let response;
      if (path) {
        response = await api.get(`/event_series/${path}?show_on_form=${show_on_form_string}&showOnlyDisabledEvents=${showOnlyDisabledEvents_string}`);
      } else {
        // If no path, get all event series instead
        response = await api.get(`/event_series`);
      }
      setEachEventSerieData(response.data);
      //console.log("Response Each event serie Data:", response.data);
    } catch (error) {
      console.log(error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const daysUntilNextEvent = (datesObject,visibleEventIds) => {
    //console.log("Dates Object:", datesObject);

    const now = new Date();

    let minDifference = Infinity;
    let found = false;

    Object.keys(datesObject).forEach((eventSerieId) => {
      const getEventDateFormatted = datesObject[eventSerieId];

      Object.entries(getEventDateFormatted).forEach(([eventId, date]) => {
        if (visibleEventIds.includes(eventId)){
        const dateFormat = new Date(date);

        if (dateFormat > now) {
          found = true;
          const difference = dateFormat - now;
          if (difference < minDifference) {
            minDifference = difference;
          }
        }
      }
      });
      
    });

    const days = Math.ceil(minDifference / (1000 * 60 * 60 * 24));
    return found ? days : 0;
  };
  const getNumbOfEvents = useCallback(async () => {
    try {
      await Promise.all(
        eventSeriesData.map(async (eventSerie) => {
          const response = await api.get(`/event_series/${eventSerie.id}`);
          
          let addTotalSubmissions = {};
          let nextEvent = {};

          

          if (response.data.events) {

            // Filter events that are visible on the form
          const visibleEvents = response.data.events.filter(event => event.show_on_form === true);

            setNumbOfEvents((prev) => ({
              ...prev,
              [eventSerie.id]: visibleEvents.length,
            }));

            await Promise.all(
              response.data.events.map(async (event) => {
                const eventResponse = await api.get(
                  `/event_series/${eventSerie.id}/event/${event.id}/`
                );

                nextEvent[event.id] = event.date || [];

                setTotalAttendees((prev) => ({
                  ...prev,
                  [event.id]: eventResponse.data.length,
                }));

                addTotalSubmissions[event.id] =
                  eventResponse.data.submissions || [];

                setListOfUserSubmissions((prev) => ({
                  ...prev,
                  [event.id]: eventResponse.data.submissions || [],
                }));
              })
            );
          }
          

          // Filter unique emails to only include those from events with show_on_form = true
          const visibleEventIds = response.data.events.filter(event => event.show_on_form === true)
          .map(event => event.id);

          const filteredUniqueEmails = new Set();

          Object.entries(addTotalSubmissions).forEach(([eventId, submissions]) => {
            if (visibleEventIds.includes(eventId)) {
              submissions.forEach((submission) => {
                if (submission.email) {
                  filteredUniqueEmails.add(submission.email);
                }
              });
            }
          });

          setNumbOfSignups((prev) => ({
            ...prev,
            [eventSerie.id]: filteredUniqueEmails.size,
          }));
          

          const daysUntil = daysUntilNextEvent({ [eventSerie.id]: nextEvent },visibleEventIds);

          setNextEventIn((prev) => ({
            ...prev,
            [eventSerie.id]: daysUntil,
          }));
        })
      );
    } catch (error) {
      console.log(error);
    }
  }, [eventSeriesData, setListOfUserSubmissions, numbOfSignups]);



//Gell all subimissions for each event
 
    const getAllSubmissionsForEachEvent = useCallback(async (eventSeriesId,eventId) => {
      setLoading(true);
 
  
      try {
        const response = await api.get(`/event_series/${eventSeriesId}/event/${eventId}/`);

        return response.data;
      } catch (error) {
        console.log(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    }, []);








  /*
    MARK FORM DATA PROVIDE
  */

  //Get all mark form data
  const getAllMarkFormData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get("/form");

      setMarkFormObject(response.data);

      //Get total number of signups
      await Promise.all(
        response.data.map(async (markForm) => {
          const response = await api.get(`/form/${markForm.id}/submissions`);
          console.log("Response DataSignUps:", response.data.length);
          setMarkFormTotalSignups((prev) => ({
            ...prev,
            [markForm.id]: response.data.length,
          }));

          setListOfMarkFormSubmissions((prev) => ({
            ...prev,
            [markForm.id]: response.data,
          }));
        })
      );

      console.log("lisOfMarkFOrm", listOfMarkFormSubmissions);

      // console.log("Response Data For Mark Form:", response.data);
    } catch (error) {
      console.log(error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  //Populate each mark form
  const handlePopulateEachMarkForm = useCallback(async (path = ``) => {
    setLoading(true);
    //console.log("Path:", path);
    try {
      const response = await api.get(`/form/${path}`);
      setPopulateEachMarkForm(response.data);

      //console.log("Response Each Mark Form Data:", response.data);
    } catch (error) {
      console.log(error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  //Get all the duplicates leads from copper
  const getCopperDuplicates = useCallback(async ()=> {
    setLoading(true);
    try {
      const response = await api.get(`/getduplicateslead`);
      setGetCopperDuplicatesLeads(response.data);
      console.log("Response Duplicates:", response.data);
    } catch (error) {
      console.log(error);
      setError(error);
    } finally {
      setLoading(false);
    }
  })

  useEffect(() => {
    getAllMarkFormData();
    //getMarkFormTotalNumbOfSignups();
  }, []);

  useEffect(() => {
    if (eventSeriesData.length > 0) {
      getNumbOfEvents();
    }
  }, [eventSeriesData]);

  return (
    <DataContext.Provider
      value={{
        eventSeriesData,
        eachEventSerieData,
        handlePopulateEventSeries,
        handlePopulateEachEventSeries,
        getAllMarkFormData,
        setMarkFormObject,
        markFormObject,
        // getMarkFormTotalNumbOfSignups,
        markFormTotalSignups,
        loading,
        error,
        numbOfEvents,
        setNumbOfEvents ,
        totalAttendees,
        listOfUserSubmissions,
        setListOfUserSubmissions,
        setEachEventSerieData,
        setEventSeriesData,
        numbOfSignups,
        setNumbOfSignups,
        nextEventIn,
        getNumbOfEvents,
        handlePopulateEachMarkForm,
        setPopulateEachMarkForm,
        populateEachMarkForm,
        setListOfMarkFormSubmissions,
        listOfMarkFormSubmissions,
        getAllSubmissionsForEachEvent,
        getCopperDuplicates,
        getCopperDuplicatesLeads,
      
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
